import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Client } from "../../models/client";
import { ScrollService } from "../../providers/scroll.service";
import { CustomPageData } from '../../models/customPageData';

declare const swal: any;


@Component({
  selector: 'app-custom-pages',
  templateUrl: './custom-pages.component.html',
  styleUrls: ['./custom-pages.component.css']
})
export class CustomPagesComponent implements OnInit, AfterViewInit {
  key: string;
  clientData: Client;
  pages: CustomPageData[];

  constructor(
    private afService: FirebaseService,
    private route: ActivatedRoute,
    private router: Router,
    private scroll: ScrollService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.afService.getClientInfo(this.key).subscribe(clientData => {
        this.clientData = clientData;
        this.afService.getCustomPages(this.key).subscribe(pages => {
          this.pages = pages;
        });
      });
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  deletePage(page: CustomPageData) {
    swal({
      title: "Are you sure?",
      text: "You will delete this page yo.",
      icon: "warning",
      buttons: true,
      dangerMode: true
    })
      .then((confirm) => {
        if (confirm) {
          this.afService.deleteCustomPage(page, this.key).then(() => this.afService.openSnackBar('Bye!'));
        }
      });
  }

  newPage() {
    this.afService.saveCustomPage(new CustomPageData(), this.key);
  }

  updateEnableCustomPagesToggle(e) {
    this.clientData.enableCustomPages = e.checked;
    this.afService.updateClient(this.clientData).then(() => {
      this.afService.openSnackBar('Client successfully updated.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/custom-pages/custom-pages.component.ts